import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type Facility = {
  name: string;
  icon: string;
  _id: string;
};

type FacilityWithIcon = {
  iconName: string;
  iconElement: JSX.Element | null;
};

export const getFacilitiesWithIcons = async (facilities: Facility[]): Promise<FacilityWithIcon[]> => {
  return facilities?.length ? await Promise.all(
    facilities?.map(async (facility) => {
      try {
        const icons = await import('@fortawesome/pro-regular-svg-icons');
        const icon = icons[facility.icon as keyof typeof icons] as IconDefinition | undefined;

        if (!icon) {
          console.warn(`Icon ${facility.icon} not found in FontAwesome library`);
          return {
            iconName: facility.name,
            iconElement: null,
          };
        }

        return {
          iconName: facility.name,
          iconElement: <FontAwesomeIcon size="sm" icon={icon} />,
        };
      } catch (error) {
        console.error(`Error loading icon ${facility.icon}:`, error);
        return {
          iconName: facility.name,
          iconElement: null,
        };
      }
    })
  ) : [];
};
